<template>
  <div class="modal">
      <div class="modal_center">
          <div class="modal_form">
            <div class="modal_form_header">
                <p>
                    {{modalTitle}}
                </p>
                <span class="mdi mdi-close" @click="closeForm"></span>
            </div>
            <div v-show="!showAuth">
                <Login @signInReset="signInReset" @signIn="signIn" />
            </div>
            <div v-show="showAuth">
                <Registration @reg="reg" />
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import Login from '@/components/Login'
import Registration from '@/components/Registration'

export default {
  name: 'modal',
  components: {
      Login, Registration
  },
  data () {
      return {
         showAuth: false,
         modalTitle: 'Вход'
      }
  },
  methods: {
    closeForm() {
        this.$emit('closeForm')
    },
    signIn() {
         this.showAuth = true
         this.modalTitle = 'Регистрация'
    },
    reg() {
         this.showAuth = false
         this.modalTitle = 'Вход'
    },
    signInReset() {
        this.showAuth = false
        this.modalTitle = 'Вход'
    },
    
    
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;
.modal {
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 9999;
    .modal_center {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .modal_form {
            width: 400px;
            padding: 30px;
            background: #fff;
            @media (max-width: @baseMedia) {
                width: 95%;
            }
            .modal_form_header {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                p {
                    font-weight: bold;
                    font-size: 20px;
                }
                span {
                    font-size: 40px;
                    cursor: pointer;
                    &:hover {
                        opacity: 0.5;
                    }
                }
            }
        }
    }
}
</style>